

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_MUNICIPIOS_POR_DEPTO = "obtenerMunicipiosPorDepto";
export const OBTENER_MUNICIPIO = "obtenerMunicipioPorDepto";
export const REGISTRAR_MUNICIPIO = "registrarMunicipio";
export const ACTUALIZAR_MUNICIPIO = "actualizarMunicipio";

export const OBTENER_MUNICIPIOS_POR_REVISOR ="obtenerMunicipiosPorRevisor"

export const OBTENER_MUNICIPIOS_POR_APROBADOR ="obtenerMunicipiosPorAprobador"
// mutation types
export const SET_MUNICIPIOS = "setMunicipios";
export const SET_MUNICIPIO = "setMunicipio";

const state = {
    municipios: [],
    municipio:[],
}

const getters = {
    obtenerMunicipiosPorDepto(state) {
      return state.asesores;
    },
}

const actions = {

    /**
     * Obtener el listado de municipios
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_MUNICIPIOS_POR_DEPTO](context, datos) {

        /*
        * Si el estado es null va a traer a todos los departamentos, de lo contrario va a traer los departamentos por estado
        *
        */
        let endpoint = 'api/Municipios';
        if(datos.departamentoId){
            endpoint = `api/Municipos/all/${datos.departamentoId}`;

            if(datos.estadoId){
                endpoint = `api/Municipos/${datos.estadoId}/${datos.departamentoId}`;
            }
                            
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },   

    /**
     * Obtener un municipio específico
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_MUNICIPIO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Municipios/`)
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_MUNICIPIO](context, datosMunicipio){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Municipios`, datosMunicipio)
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_MUNICIPIO](context, datosMunicipio){
        let id = datosMunicipio.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Municipios/`, datosMunicipio)
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },


    /**
     * Obtener los municipios asignados a un revisor o aprobador por departamento, periodo y usuario ID
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */

    async [OBTENER_MUNICIPIOS_POR_REVISOR](context, datos) {

        let endpoint =  `api/Municipios/MunicipiosRevisor/${datos.departamentoId}/${datos.periodoId}/${datos.usuarioId}`;
            

        //console.log(datos)

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },   


    /**
     * Obtener los municipios que tiene asigandos un aprobador por departamento y periodo
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_MUNICIPIOS_POR_APROBADOR](context, datos) {

        let endpoint =  `api/Municipios/MunicipiosAprobador/${datos.departamentoId}/${datos.periodoId}/${datos.usuarioId}`;
            

        //console.log(datos)

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_MUNICIPIOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },   
  }

const mutations = {
    [SET_MUNICIPIOS](state, data) {
        state.municipios = data;
    },

    [SET_MUNICIPIO](state, data) {
        state.municipio = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}